import { Link } from "react-router-dom";
import Input from "../../../components/input/input";
import Label from "../../../components/label/label";

function ObContact({ onNext, onBack, formData, onUpdateData }) {
    const handleNextClick = () => {
        onNext(formData);
    };

    const handleBackClick = () => {
        onBack();
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        onUpdateData({ [name]: value });
    };

    return (
        <div>
            <h2>Jetzt wie du erreichbar bist.</h2>
            <Label labelFor="phoneNumber" labelValue="Telefon: " /><br/>
            <Input
                inputType="text"
                inputName="phoneNumber"
                inputValue={formData.phoneNumber || ''}
                onChange={handleInputChange}
                borderColor="black"
            /><br />
            <Label labelFor="companyName" labelValue="Firmenname: " /><br/>
            <Input
                inputType="text"
                inputName="companyName"
                inputValue={formData.companyName || ''}
                onChange={handleInputChange}
                borderColor="black"
            /><br />
            <Label labelFor="website" labelValue="Website: " /><br/>
            <Input
                inputType="text"
                inputName="website"
                inputValue={formData.website || ''}
                onChange={handleInputChange}
                borderColor="black"
            />
            <div className="linkContainer">
                <Link onClick={handleBackClick}>Zurück</Link>
                <Link onClick={handleNextClick}>Weiter</Link>
            </div>
        </div>
    );
}

export default ObContact;